<template>
    <div id="register-step">
        <div class="card">
            <template v-if="hasSteps">
                <div class="card-header">
                    <Steps
                        :steps="steps"
                        :order-step="orderStep"
                    />
                </div>
            </template>

            <div class="card-body">
                <template v-if="ready">
                    <div class="row">
                        <div class="col">
                            <div style="max-width: 700px">
                                <h3 class="cursus-register__step-title mb-4">
                                    <slot name="title">
                                        <template v-if="currentStep">
                                            {{ currentStep.label }}
                                        </template>
                                    </slot>
                                </h3>
                            </div>
                        </div>
                        <template v-if="$slots.aside">
                            <div class="col-md-auto">
                                <slot name="aside" />
                            </div>
                        </template>
                    </div>
                    <slot />
                </template>
                <template v-else>
                    <div class="d-flex align-items-center justify-content-center" style="min-height: 200px">
                        <div class="spinner-grow text-primary"></div>
                    </div>
                </template>
            </div>

            <template v-if="$slots.append">
                <div class="card-footer bg-transparent py-4">
                    <slot name="append" />
                </div>
            </template>


            <template v-if="showSubmit">
                <div class="card-footer bg-transparent py-4">
                    <div class="row align-items-center justify-content-center">
                        <template v-if="previousRoute">
                            <div class="col-auto">
                                <router-link :to="previousRoute" custom v-slot="{ href, navigate }">
                                    <a class="btn btn-link" :class="{ 'disabled': loading }" :href="href" @click="navigate">
                                        &lt;&nbsp;&nbsp;Précédent
                                    </a>
                                </router-link>
                            </div>
                        </template>

                        <div class="col-auto">
                            <button class="btn btn-primary btn-lg" type="button" :disabled="loading" @click="handleSubmitClicked" key="next">
                                <template v-if="loading">
                                    <span class="row align-items-center mx-n2">
                                        <span class="col px-2">
                                            Envoi...
                                        </span>
                                        <span class="col-auto px-2">
                                            <span class="spinner spinner-grow spinner-grow-sm d-block"></span>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="submitLabel">
                                    {{ submitLabel }}
                                </template>
                                <template v-else>
                                    Suivant&nbsp;&nbsp;&gt;
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Steps from "../ui/Steps";

    export default {
        components: {
            Steps
        },
        props: {
            ready: {
                type: Boolean,
                default: true,
            },
            loading: Boolean,
            submitLabel: String,
            previousRoute: Object,
            steps: Array,
            currentStep: Object,
            orderStep: String,
            showSubmit: {
                type: Boolean,
                default: true,
            },
        },
        watch: {
            ready: {
                immediate: true,
                handler: 'handleReadyChanged',
            },
        },
        computed: {
            hasSteps() {
                return this.steps?.length > 1;
            },
        },
        methods: {
            handleSubmitClicked() {
                this.$emit('submit');
            },
            handleReadyChanged() {
                if(!this.ready) {
                    return;
                }
                if(this.$route.query.previous) {
                    this.$router.replace({
                        name: this.$route.name,
                        query: {
                            ...this.$route.query,
                            previous: undefined,
                        },
                    });
                }
            },
        }
    }
</script>
